<template>
  <div id="submitted">
    <form>
      <ol class="questions">
        <li>
          <fieldset>
            <legend>
              <div class="alert alert-success" role="alert">
                <h2 id="submittedTitle"><i class="fa fa-check-circle"></i>Thank you for your request</h2>
                <p>Your record has been submitted to RBDM successfully and an email has been issued to
                  you confirming this. Please print off the form and bring this with you to your marriage 
                  interview at our office.
                </p>
              </div>
            </legend>
            <ul class="actions">
                <li>
                  <em><a v-on:click="resetForm" id="return" class="button">Return to page</a></em> 
                </li>
            </ul>
          </fieldset>
        </li>
      </ol>
    </form>
  </div>
</template>

<script>

export default {
  name: 'Submitted',
  props: { 
      resetEnquiry: Function      
  },
  methods: {
    resetForm: function() {
      this.$emit('resetEnquiry');
    }
  }
}
</script>
  
<style scoped lang="scss">
#submitted {
  min-height: 20em;
}
#return {
  margin-top: 3em;
  color: white !important;
  text-decoration: none !important;
}
</style>